<template>
  <v-container>
    <template v-if="assertSetting('miscCheckIn', 1)">
      <v-btn @click="updateGatePassCheckIn({gatePassID: gatePassID})"> Check In </v-btn>
      <v-btn @click="updateGatePassRenew({gatePassID: gatePassID})"> Renew </v-btn>
    </template>
    <v-layout row>
      <v-flex xs6>
        <v-layout
          row
          align-center
        >
          <v-flex>
            <v-avatar
              size="75px"
              tile>
              <img
                src="@/assets/logo.png"
                alt="Baxter State Park"
              >
            </v-avatar>
          </v-flex>
          <v-flex>
            <h1>Baxter State Park Gate Pass</h1>
          </v-flex>
        </v-layout>
        <h2 class="mt-4">{{ gatePass.year ? gatePass.year + ' Season Gate Pass' : 'Standard Gate Pass' }}</h2>
        <p>
          Please print this pass and present it at the gatehouse when you enter.
          Gate passes are required for out of state visitors.
          No Pets. No Motorcycles. No Oversize Vehicles (Maximum
          9' high, 7' wide, or 22' long). Standard Gate Passes provide access to the park for the duration of a continuous visit.
          Season Gate Passes provide access to the park for the entire season.
        </p>
        <v-divider class="my-4"/>
        <v-layout justify-center>
          <VueQrcode
            :value="qrData"
            :options="{ size: 300 }"
          />
        </v-layout>
        <v-divider class="my-4"/>
        <h3>Registration Information</h3>
        <p>
          ID: {{ gatePass.gatePassID }}<br>
          Person ID: {{ person.personID }}<br>
          Last Name: {{ person.lastName }}<br>
          Number in Party: ________
        </p>
      </v-flex>
      <v-flex xs6>
        <img
          src="@/assets/speedLimit.png"
          alt="Baxter State Park"
        >
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VueQrcode from '@xkeshi/vue-qrcode'

export default {
  components: {
    VueQrcode
  },
  data () {
    return {
      gatePassID: this.$route.params.id
    }
  },
  computed: {
    ...mapGetters({
      gatePass: 'passes/gatePass',
      person: 'person/person'
    }),
    qrData () {
      return JSON.stringify({
        type: 'gatePass',
        ID: this.gatePassID,
        personID: this.person.personID
      })
    }
  },
  mounted () {
    let gatePass = {
      gatePassID: this.gatePassID
    }
    this.getGatePass(gatePass)
  },
  methods: {
    ...mapActions({
      getGatePass: 'passes/getGatePass',
      updateGatePassCheckIn: 'passes/updateGatePassCheckIn',
      updateGatePassRenew: 'passes/updateGatePassRenew'
    })
  }
}
</script>

<style>
/*
  @media print{
    html, body, .container {
      height:100vh;
      overflow: hidden !important;
     }
    @page {
      size: landscape;
    }
  }
  */
</style>
